import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from "@/store";
import axios from "axios";
import {
    required,
    maxLength
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "PaymentMethodCreate",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            payment_method: "",
            description: "",
            submitted: false,
            disabled: false,
            methodExists: false,
            opening_balance: "0"
        };
    },

    validations: {
        payment_method: {
            required,
            maxLength: maxLength(100)
        },
        description: {
            maxLength: maxLength(1000)
        },
        opening_balance: {
            customRequired(value) {
                return value !== null && value !== undefined && value !== "";
            },
            customNumeric(value) {
                if (value === null || value === undefined || value === "") return true;
                return !isNaN(Number(value));
            },
            customMinValue(value) {
                if (value === null || value === undefined || value === "") return true;
                return Number(value) >= 0;
            },
        },
    },
    methods: {
        async checkDuplicateMethod() {
            if (!this.payment_method) {
                this.methodExists = false;
                return;
            }
            try {
                const response = await axios.get("/paymentMethod/checkDuplicateMethod", {
                    params: {
                        payment_method: this.payment_method,
                    },
                });
                this.methodExists = response.data.exists;
                this.submitted = false;
                this.disabled = false;
            } catch (error) {
                console.error('An error occurred:', error);
            }
        },

        async confirmRegister() {
            if (this.disabled) return;
            this.submitted = true;
            this.disabled = true;
            await this.checkDuplicateMethod();
            if(this.methodExists){
                this.$notification.error("Payment method already existed.", {
                    timer: 3,
                    position: "bottomCenter"
                });
                return;
            }
            this.register();
        },

        register() {
            this.submitted = true;
            if (this.$v.$invalid) {
                this.disabled = false;
                return;
            }
            this.disabled = true;
            var request = {
                payment_method: this.payment_method,
                description: this.description,
                opening_balance: this.opening_balance,
                login_id: store.state.user.id,
                campus_id: store.state.user.campus_id,
            }
            axios.post("/paymentMethod/create", request, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data) {
                        this.$notification.success("Payment Method Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        if (this.$route.query.rd_back == 'paymentMethod') {
                            this.$router.push({
                                name: "paymentMethodCreate"
                            });
                        } else {
                            this.$router.push({
                                name: "paymentMethodList"
                            });
                        }
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.disabled = false;
                    console.log("Payment Method Create API Error", error.errors);
                });
        },

        showList() {
            this.$router.push({
                path: "/paymentMethod/list"
            });
        },

        handleKeydown(event) {
            const key = event.key;
            const value = event.target.value;
            const decimalIndex = value.indexOf('.');
            const hasDecimal = decimalIndex !== -1;
            const cursorPos = event.target.selectionStart;

            // Allow control keys
            if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter', 'Home', 'End'].includes(key)) {
                return;
            }

            // Allow decimal point only once
            if (key === '.') {
                if (hasDecimal) {
                    event.preventDefault();
                }
                return;
            }

            // Allow only digits
            if (!/^[0-9]$/.test(key)) {
                event.preventDefault();
                return;
            }

            // If current value is exactly "0" and user enters a digit, replace the 0 with that digit
            if (value === "0" && !hasDecimal) {
                event.preventDefault();
                this.opening_balance = key;
                // Set cursor to end
                this.$nextTick(() => {
                    event.target.setSelectionRange(1, 1);
                });
                return;
            }

            // Check integer part length limit (max 16 digits before decimal)
            let integerPart = hasDecimal ? value.substring(0, decimalIndex) : value;
            if (cursorPos <= decimalIndex || !hasDecimal) {
                const newIntegerLength = integerPart.length + 1;
                if (newIntegerLength > 14) {
                    event.preventDefault();
                    return;
                }
            }

            // Check decimal places limit
            if (hasDecimal) {
                const beforeCursor = value.substring(0, cursorPos);
                const afterCursor = value.substring(cursorPos);
                const newValue = beforeCursor + key + afterCursor;
                const newDecimalIndex = newValue.indexOf('.');
                const newDecimalPart = newValue.substring(newDecimalIndex + 1);

                if (newDecimalPart.length > 2) {
                    event.preventDefault();
                    return;
                }
            }
        },

        getCurrentDateString() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const day = String(today.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
    },
};
